export default {"src":"/_next/static/media/copy.262405de.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};